import React, { ChangeEvent, useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Button, Col, Row } from 'react-bootstrap';

import Loading from '../../../../components/Loading';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import getResponseErrors from '../../../../utils/getResponseErrors';

import { ContainerDados, Content } from './styles';
import CheckboxContainer from '../CheckboxContainer';

interface IFormBusca {
  usuPermissao: string;
}

type Props = {
  usuCodigo: number;
  permissoes: string;
  handleDadosSalvos(dados: { UsuCodigo: number; UsuPermissao: string }): void;
};

const Permissoes: React.FC<Props> = ({
  usuCodigo,
  permissoes,
  handleDadosSalvos,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const formRefBusca = useRef<FormHandles>(null);

  const handleSalvar = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        const response = await api.patch(`/users/permission/${usuCodigo}`, {
          UsuPermissao: dados.usuPermissao,
        });

        const permissaoSalva = response.data.UsuPermissao;
        handleDadosSalvos({
          UsuCodigo: usuCodigo,
          UsuPermissao: permissaoSalva,
        });
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar dados',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, usuCodigo, handleDadosSalvos],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      <ContainerDados className="rounded">
        <Content>
          <>
            <Row noGutters>
              <Col md={12}>
                <Form ref={formRefBusca} onSubmit={handleSalvar}>
                  <CheckboxContainer
                    name="usuPermissao"
                    permissoes={permissoes}
                  />
                </Form>
              </Col>
              <Col md={12}>
                <Row noGutters>
                  <Button
                    type="button"
                    onClick={() => formRefBusca?.current?.submitForm()}
                    size="sm"
                    variant="danger"
                  >
                    Salvar Permissões
                  </Button>
                </Row>
              </Col>
            </Row>
          </>
        </Content>
      </ContainerDados>
    </>
  );
};

export default Permissoes;
